import React, { useContext } from "react";
import { responsiveProps } from "../constant/ResponsiveProps.js";
import Responsive from "@amzn/meridian/responsive";

/*
This acts as common context and it will provide context related to device info and layout
Currently It is using Responsive Component from Meridian library to decide the applicable properties.
*/

const DeviceLayoutContext = React.createContext();

export const useDeviceLayout = () => {
  return useContext(DeviceLayoutContext);
};

export const DeviceLayoutProvider = ({ children }) => {
  return (
    <Responsive query="max-width" props={responsiveProps}>
      {({ spacingInset_shorthand2, spacingInset_shorthand4, isMobile }) => (
        <DeviceLayoutContext.Provider
          value={{ spacingInset_shorthand2, spacingInset_shorthand4, isMobile }}
        >
          {children}
        </DeviceLayoutContext.Provider>
      )}
    </Responsive>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/context/DeviceLayoutContext.js